<template>
  <div class="account_setting_box">
    <div class="setting_box">
      <div class="setting_box_item">
        <p class="item_title">{{ $t('center.Change_Password') }}</p>
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-position="top" class="demo-ruleForm"
          style="width: 450px;">
          <el-form-item :label="$t('center.Current_password')" prop="oldPwd">
            <el-input type="password" v-model="ruleForm.oldPwd" :placeholder="$t('center.old_password')"
              show-password></el-input>
          </el-form-item>
          <el-form-item :label="$t('center.New_password')" prop="newPwd">
            <el-input type="password" v-model="ruleForm.newPwd" :placeholder="$t('center.letters_numbers')"
              show-password></el-input>
          </el-form-item>
          <el-form-item :label="$t('center.Confirm_Password')" prop="confirmNwd">
            <el-input v-model="ruleForm.confirmNwd" :placeholder="$t('center.password_again')" show-password></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')" style="width: 80px;">
              {{ $t('center.save') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="setting_box_item" v-if="partnerInfo.personType == 1">
        <p class="item_title">{{ $t('center.Modify_mailbox') }}</p>
        <p style="font-size: 14px;margin-top: 20px;">
          {{ $t('center.Current_mailbox') }}:
          <span style="margin-left: 10px;margin-bottom: 20px;display: inline-block;">{{
          JSON.parse($common.isLogin()).email
        }}</span>
          <el-form :model="emailForm" status-icon :rules="emailRule" ref="emailForm" label-position="top"
            class="demo-ruleForm" style="width: 450px;">
            <el-form-item :label="$t('booking.email')" prop="email">
              <el-input v-model="emailForm.email" :placeholder="$t('register.enter_mailbox')"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="changeEmial()" style="width: 80px;">
                {{ $t('center.save') }}
              </el-button>
            </el-form-item>
          </el-form>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    var checkOldPwd = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('center.old_password')));
      } else {
        callback();
      }
    };
    var checknewPwd = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('center.enter_new_password')));
      } else {
        let reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/
        if ((value.length >= 8 && value.length <= 20) && reg.test(value)) {
          callback();
        } else {
          return callback(new Error(this.$t('center.password_format')));
        }
      }
    };
    var checkConfirmNwd = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('center.enter_new_password')));
      } else {
        if (value == this.ruleForm.newPwd) {
          callback();
        } else {
          return callback(new Error(this.$t('center.passwords_differ')));
        }
      }
    };
    var checkEmail = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('register.enter_mailbox')))
      } else {
        let regExp = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9_-]+\.([a-zA-Z]{2,4})$/
        if (regExp.test(value)) {
          callback();
        } else {
          return callback(new Error(this.$t('center.mailbox_format')))
        }
      }
    }
    return {
      ruleForm: {
        newPwd: '',
        confirmNwd: '',
        oldPwd: '',
        updateWhat: 1
      },
      rules: {
        oldPwd: [
          { validator: checkOldPwd, trigger: 'blur' }
        ],
        newPwd: [
          { validator: checknewPwd, trigger: 'blur' }
        ],
        confirmNwd: [
          { validator: checkConfirmNwd, trigger: 'blur' }
        ]
      },
      emailForm: {
        email: '',
        updateWhat: 2
      },
      emailRule: {
        email: [
          { validator: checkEmail, trigger: 'blur' }
        ]
      },
      partnerInfo: {}
    };
  },
  created () {
    this.partnerInfo = JSON.parse(localStorage.getItem('partnerInfo'))
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm(this.$t('center.confirm_change'), this.$t('header.Reminder'), {
            confirmButtonText: this.$t('header.confirm'),
            cancelButtonText: this.$t('header.cancel'),
            type: 'warning'
          }).then(() => {
            if (this.partnerInfo.personType == 1) {
              this.changePwd()
            } else {
              this.changeSubPwd()
            }
          }).catch(() => {

          });
        } else {
          return false;
        }
      });
    },
    async changePwd () {
      let headerReq = {
        accessToken: this.$common.isLogin() ? JSON.parse(this.$common.isLogin()).token : ''
      }
      const { data: result } = await this.$http.post('/mini/uptPartner', this.ruleForm, { headers: headerReq })
      if (result.code != 200) return this.$message.error(result.message)
      this.$alert(this.$t('center.login_again'), this.$t('center.Modified_successfully'), {
        confirmButtonText: this.$t('header.confirm'),
        callback: action => {
          this.$common.loginOut(true, true);
        }
      });
    },
    async changeSubPwd () {
      let headerReq = {
        accessToken: this.$common.isLogin() ? JSON.parse(this.$common.isLogin()).token : ''
      }
      const { data: result } = await this.$http.post('/mini/uptSubAccount', this.ruleForm, { headers: headerReq })
      if (result.code != 200) return this.$message.error(result.message)
      this.$alert(this.$t('center.login_again'), this.$t('center.Modified_successfully'), {
        confirmButtonText: this.$t('header.confirm'),
        callback: action => {
          this.$common.loginOut(true, true);
        }
      });
    },
    changeEmial () {
      this.$refs['emailForm'].validate((valid) => {
        if (valid) {
          this.$confirm(this.$t('center.confirm_email'), this.$t('header.Reminder'), {
            confirmButtonText: this.$t('header.confirm'),
            cancelButtonText: this.$t('header.cancel'),
            type: 'warning'
          }).then(() => {
            this.toChangeEamil();
          }).catch(() => {

          });
        }
      });
    },
    async toChangeEamil () {
      let headerReq = {
        accessToken: this.$common.isLogin() ? JSON.parse(this.$common.isLogin()).token : ''
      }
      let reqData = {
        email: this.emailForm.email,
        updateWhat: this.emailForm.updateWhat
      }
      const { data: result } = await this.$http.post('/mini/uptPartner', reqData, { headers: headerReq })
      if (result.code != 200) return this.$message.error(result.message)
      let partnerInfo = JSON.parse(localStorage.getItem('partnerInfo'))
      partnerInfo.email = result.data.email;
      localStorage.setItem('partnerInfo', JSON.stringify(partnerInfo))
      this.$alert(this.$t('center.emial_change_success'), this.$t('center.Modified_successfully'), {
        confirmButtonText: this.$t('header.confirm'),
        callback: action => {
          location.reload();
        }
      });
    }
  }
}
</script>

<style lang="less" scoped>
.account_setting_box {
  .setting_box {
    width: 100%;

    .setting_box_item {
      min-height: 150px;
      background-color: #fff;
      margin-bottom: 20px;
      padding: 20px;

      .item_title {
        font-size: 16px;
        font-weight: bold;
        font-family: '苹方';
        margin-bottom: 12px;
      }
    }

  }

  /deep/.el-form--label-top .el-form-item__label {
    padding: 0;
  }

  /deep/.el-form-item__label {
    height: 30px;
    line-height: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/newPages/order/AccountSetting.vue